<template>
    <div class="min-h-screen bg-gray-50">
        <Header />
        <div class="container mx-auto py-6 pb-16">
            <div class="flex flex-col lg:flex-row gap-8">
                <div class="product-detail w-full">
                    <nav class="breadcrumb">
                        <router-link to="/">首页</router-link><span>/</span>
                        <router-link to="/product">数字产品</router-link><span>/</span>
                        <router-link v-if="product" to="/product">{{ getDictLabelByValue(product.category) }}</router-link><span v-if="product">/</span>
                        <span>{{ product ? product.name : '产品详情' }}</span>
                    </nav>

                    <div v-if="product" class="detail-main">
                        <div class="card">
                            <div class="product-top">
                                <div class="product-left">
                                    <div class="product-image">
                                        <img v-if="product.imageUrl" :src="getFullImageUrl(product.imageUrl)" :alt="product.name">
                                        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                                    </div>
                                    <div class="price-block">
                                        <div class="member-price-row">
                                            <div class="label-wrap">
                                                <span class="label">{{ product.discount ? '会员价' : '价格' }}</span>
                                            </div>
                                            <div class="member-price">
                                                <span class="currency">&yen;</span>
                                                <span class="amount">{{ product.discount ? product.memberPrice : product.price }}</span>
                                                <span class="suffix">元</span>
                                                <span v-if="product.priceUnit && product.priceUnit !== '003'" class="price-unit">/{{ getSubscriptionPeriodByValue(product.priceUnit) }}</span>
                                            </div>
                                            <div v-if="product.discount && product.discount !== 10" class="member-note">
                                                <span class="label">原价</span>
                                                <span class="price-original">&yen;{{ product.price }}元</span>
                                                <svg class="note-icon" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                                </svg>
                                                会员享{{ discountText(product.discount) }}优惠
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="product-right">
                                    <div class="product-info">
                                        <h1 class="product-name">{{ product.name }}</h1>
                                        <div class="product-tags">
                                            <span>{{ getDictLabelByValue(product.category) }}</span>
                                            <span>{{ getDictLabelByValue(product.domain) }}</span>
                                        </div>
                                        <p class="product-desc-short">{{ product.description }}</p>
                                        <div class="product-meta">
                                            <div class="product-meta-row">
                                                <strong>供应商：</strong>{{ product && product.companyName ? product.companyName : "暂无" }}
                                            </div>
                                            <div class="product-meta-row">
                                                <strong>所属领域：</strong>{{ product && getDictLabelByValue(product.category) ? getDictLabelByValue(product.category) : "-" }} / {{ product && getDictLabelByValue(product.domain) ? getDictLabelByValue(product.domain) : "-" }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-title">产品配置</div>
                            <div class="desc-text">{{ product.config }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">产品描述</div>
                            <div class="desc-text">{{ product.description }}</div>
                        </div>

                        <div class="card">
                            <div class="card-title">供应商信息</div>
                            <div class="supplier-info">
                                <div class="supplier-avatar">{{ product && product.companyName ? product.companyName.slice(0, 1) : "" }}</div>
                                <div>
                                    <div class="supplier-name">{{ product && product.companyName ? product.companyName : "暂无供应商" }}</div>
                                    <div class="supplier-desc">优质供应商，产品已入驻数字产品超市</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="not-found">
                        <h2>产品不存在</h2>
                        <p>未找到该产品信息，请返回列表页浏览</p>
                        <router-link to="/product" class="btn-primary">返回产品列表</router-link>
                    </div>
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import {CURRENT_CONFIG} from "@/api/config";
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'
import {api} from "@/api";
import { useHead } from '@unhead/vue';
import { ref, computed } from 'vue';
export default {
    name: 'ProductDetail.vue',
    components: {
        Header,
        AppFooter
    },
    setup() {
        const product = ref({});
        const BASE_URL = CURRENT_CONFIG.BASE_URL;

        const title = computed(() =>
            product.value.name
        );
        const description = computed(() =>
            product.value.description
        );
        const image = computed(() => {
            if (!product.value.imageUrl) return '';
            const baseUrl = BASE_URL.endsWith('/') ? BASE_URL : BASE_URL + '/';
            const imgPath = product.value.imageUrl.startsWith('/') ? product.value.imageUrl.substring(1) : product.value.imageUrl;
            return baseUrl + imgPath;
        });

        useHead({
            title,
            meta: computed(() => [
                { property: 'og:title', content: title.value },
                { property: 'og:description', content: description.value },
                { property: 'og:type', content: 'product' },
                { name: 'description', content: description.value },
                ...(image.value ? [{ property: 'og:image', content: image.value }] : [])
            ])
        });

        return { productRef: product };
    },
    data() {
        return {
            loading: false,
            BASE_URL: CURRENT_CONFIG.BASE_URL,
            product: {},
            productId: null,
            dictList: [],
            biz_subscription_period_type: []
        }
    },
    watch: {
        product: {
            handler(val) {
                if (val && val.name) {
                    this.productRef = val;
                }
            },
            deep: true
        }
    },
    mounted() {
        // 从路由参数中获取产品ID
        this.productId = this.$route.params.id;
        this.getDataBizSubscriptionPeriodType()
        // 先获取字典数据，再获取产品详情
        this.getDataDictList().then(() => {
            this.getProductDetail()
        });
    },
    methods: {
        price(value) {
            return value.toLocaleString()
        },
        discountText(value) {
            return `${Number(value).toFixed(1).replace(/\.0$/, '')}折`
        },
        // 根据字典值获取对应的标签文字
        getDictLabelByValue(value) {
            if (!value) return '';
            const dictItem = this.dictList.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        getSubscriptionPeriodByValue(value) {
            if (!value) return '';
            const dictItem = this.biz_subscription_period_type.find(item => item.dictValue === value);
            return dictItem ? dictItem.dictLabel : value;
        },
        async getProductDetail() {
            this.product = {}
            const result = await api.getProductDetailApi(this.productId)
            if (result.code === 200) {
                this.product = result.data
            }
        },
        // 获取数据字典
        async getDataDictList() {
            this.dictList = [];
            const dictType = 'biz_digital_product_type';
            const result = await api.getDataDictApi(dictType);
            if (result.code === 200) {
                this.dictList = result.rows;
            }
        },
        async getDataBizSubscriptionPeriodType() {
            this.biz_subscription_period_type = []
            const dictType = 'biz_subscription_period_type'
            const result = await api.getDataDictApi(dictType)
            if (result.code === 200) {
                this.biz_subscription_period_type = result.rows
            }
        },
        getFullImageUrl(path) {
            if (!path) return '';
            const baseUrl = this.BASE_URL.endsWith('/') ? this.BASE_URL : this.BASE_URL + '/';
            const imgPath = path.startsWith('/') ? path.substring(1) : path;
            return baseUrl + imgPath
        },
    }
}
</script>
<style scoped>
.product-detail { color: #333; }
.breadcrumb { display: flex; align-items: center; max-width: none; margin: 0 0 24px; padding: 12px 16px; background: #fff; border-radius: 8px; box-shadow: 0 1px 4px rgba(0,0,0,.04); font-size: 13px; color: #999; }
.breadcrumb a { color: #2d6bc4; text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb span { margin: 0 6px; }
.detail-main { max-width: 1100px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }
.card { background: #fff; border-radius: 12px; padding: 28px; box-shadow: 0 2px 12px rgba(0,0,0,.06); }
.card-title { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; position: relative; }
.card-title::after { content: ''; position: absolute; bottom: -2px; left: 0; width: 40px; height: 2px; background: #2d6bc4; }
.product-top { display: flex; gap: 32px; align-items: stretch; }
.product-left { width: 380px; flex-shrink: 0; display: flex; flex-direction: column; gap: 0; }
.product-right { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.product-image { width: 100%; height: 260px; background: linear-gradient(135deg, #f0f4ff 0%, #e4ecfe 100%); border-radius: 16px; display: flex; align-items: center; justify-content: center; overflow: hidden; border: 1px solid rgba(45,107,196,.06); }
.product-image img { max-height: 100%; max-width: 100%; object-fit: contain; }
.product-image svg { width: 80px; height: 80px; color: #b8c8e8; }
.product-info { flex: 1; display: flex; flex-direction: column; padding-top: 4px; }
.product-name { font-size: 24px; font-weight: 700; color: #1a1a2e; margin-bottom: 14px; line-height: 1.35; }
.product-tags { display: flex; gap: 8px; margin-bottom: 18px; flex-wrap: wrap; }
.product-tags span { padding: 5px 16px; background: #eef3ff; color: #2d6bc4; border-radius: 6px; font-size: 13px; font-weight: 500; letter-spacing: .2px; }
.product-desc-short { font-size: 14px; color: #666; line-height: 1.85; flex: 1; margin-bottom: 20px; }
.product-meta { border-top: 1px solid #f0f0f0; padding-top: 16px; }
.product-meta-row { display: flex; gap: 6px; font-size: 13px; color: #888; margin-bottom: 8px; line-height: 1.5; }
.product-meta-row strong { color: #555; font-weight: 500; }
.desc-text { font-size: 14px; color: #666; line-height: 2; white-space: pre-wrap; }
.supplier-info { display: flex; align-items: center; gap: 16px; }
.supplier-avatar { width: 56px; height: 56px; background: #f0f5ff; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: #2d6bc4; font-weight: 700; font-size: 20px; }
.supplier-name { font-size: 16px; font-weight: 600; color: #1a1a2e; margin-bottom: 4px; }
.supplier-desc { font-size: 13px; color: #999; }
.not-found { text-align: center; padding: 80px 20px; background: #fff; border-radius: 12px; }
.not-found h2 { font-size: 24px; color: #999; margin-bottom: 16px; }
.not-found p { color: #999; margin-bottom: 20px; }
@media (max-width: 900px) { .product-top { flex-direction: column; } .product-left { width: 100%; flex-direction: row; gap: 20px; } .product-image { width: 200px; height: 160px; flex-shrink: 0; } .price-block { flex: 1; padding-top: 0; } }
@media (max-width: 600px) { .product-left { flex-direction: column; } .product-image { width: 100%; height: 200px; } .price-actions { flex-direction: column; } .btn-secondary { min-width: unset; } .amount { font-size: 30px; } }

.price-block { padding: 20px 5px 0; position: relative; }
.discount-badge { position: absolute; top: 8px; right: 0; display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%); color: #fff; font-size: 13px; font-weight: 700; border-radius: 20px; letter-spacing: .5px; box-shadow: 0 4px 14px rgba(238,90,36,.35); animation: badgeBounce 2s ease-in-out infinite; }
.badge-pulse { display: inline-block; width: 7px; height: 7px; background: #fff; border-radius: 50%; animation: pulseDot 1.5s ease-in-out infinite; }
@keyframes badgeBounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
@keyframes pulseDot { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: .5; transform: scale(1.8); } }
.price-original-row { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.price-original-row .label { font-size: 13px; color: #999; font-weight: 500; min-width: 32px; }
.price-original { font-size: 15px; color: #b0b0b0; text-decoration: line-through; font-weight: 500; }
.member-price-row { background: linear-gradient(135deg, #fdfcfb 0%, #f7f4f9 100%); border-radius: 12px; padding: 16px 18px; border: 1px dashed #e2d8f0; position: relative; }
.label-wrap { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.label-wrap .label { font-size: 13px; color: #7c6fa0; font-weight: 600; letter-spacing: .5px; text-transform: uppercase; }
.label-tag { font-size: 11px; padding: 2px 8px; background: #667eea; color: #fff; border-radius: 10px; font-weight: 600; letter-spacing: .5px; animation: tagGlow 2.5s ease-in-out infinite; }
@keyframes tagGlow { 0%, 100% { box-shadow: 0 0 0 0 rgba(102,126,234,.4); } 50% { box-shadow: 0 0 0 8px rgba(102,126,234,0); } }
.member-price { display: flex; align-items: baseline; gap: 2px; margin-bottom: 6px; }
.currency { font-size: 18px; font-weight: 700; color: #5b4a8a; align-self: flex-start; margin-top: 4px; }
.amount { font-size: 38px; font-weight: 800; color: #3d2c6b; line-height: 1; letter-spacing: -1px; }
.suffix { font-size: 16px; font-weight: 600; color: #5b4a8a; align-self: flex-end; margin-bottom: 4px; }
.price-unit { font-size: 14px; color: #8b7daf; font-weight: 500; align-self: flex-end; margin-bottom: 3px; margin-left: 2px; }
.member-note { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #8b7daf; font-weight: 500; }
.note-icon { width: 14px; height: 14px; color: #4ecb71; flex-shrink: 0; }
.price-actions { display: flex; gap: 10px; padding: 14px 5px 0; }
.btn-primary, .btn-secondary { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 12px 20px; border: 0; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all .25s ease; letter-spacing: .3px; white-space: nowrap; }
.btn-primary { flex: 1; background: linear-gradient(135deg, #667eea 0%, #5a67d8 100%); color: #fff; box-shadow: 0 4px 16px rgba(102,126,234,.35); }
.btn-primary:hover { background: linear-gradient(135deg, #5a67d8 0%, #4c51bf 100%); box-shadow: 0 6px 22px rgba(102,126,234,.5); transform: translateY(-1px); }
.btn-primary:active { transform: translateY(0) scale(.98); box-shadow: 0 2px 8px rgba(102,126,234,.3); }
.btn-secondary { flex: 1; background: #f5f3f9; color: #5b4a8a; min-width: 100px; }
.btn-secondary:hover { background: #ebe6f5; transform: translateY(-1px); }
.btn-secondary:active { transform: translateY(0) scale(.98); background: #e0d8ed; }
.btn-icon { width: 17px; height: 17px; flex-shrink: 0; }
</style>
